import { Input } from '@perch-labs/shrike';
import styled from 'styled-components';
import { Text } from '~/components/typography';

export const StyledInput = styled(Input)`
  label {
    font-family: ${props => props.theme.fontFamilies.main.medium};
  }

  ${props =>
    props.readOnly &&
    `
    div {
      background-color: ${props.theme.colors.background.tertiary};
      opacity: ${props.theme.opacities.medium};
    }
    `}
`;

export const Requirements = styled(Text)<{ isValid?: boolean }>`
  margin-top: 8px;

  ${props => {
    if (props.isValid) {
      return `color: ${props.theme.colors.content.accent4};`;
    } else {
      return `opacity: ${props.theme.opacities.medium};`;
    }
  }}
`;

interface InputWithIconWrapperProps {
  hasIcon?: boolean;
}

export const InputWithIconWrapper = styled.div<InputWithIconWrapperProps>`
  position: relative;

  .help-icon {
    position: absolute;
    right: 12px;
    top: calc(1.5rem + 18px); /* Adjust based on your label height + input padding */
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    z-index: 1;
    pointer-events: none;

    /* Ensure the icon doesn't move when error appears */
    margin-top: 0 !important;

    > * {
      pointer-events: auto;
    }

    svg {
      width: 16px;
      height: 16px;
      color: ${props => props.theme.colors.content.primary};
    }

    a {
      &:hover,
      &:focus,
      &:active {
        outline: none;
        box-shadow: none;
      }
    }
  }

  input {
    padding-right: ${props => (props.hasIcon ? '40px' : '12px')} !important;
  }
`;
